import React, { useContext } from 'react';
import LocalizationGroup from './components/LocalizationGroup/LocalizationGroup';
import classNames from 'classnames';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './InputFields.module.scss';

interface IInputFields {
	languageId: string;
	isVisible: boolean;
}

const InputFields: React.FC<IInputFields> = ({ languageId, isVisible }) => {
	const { localizationData } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses}>
			{localizationData?.groups.map((el) => (
				<LocalizationGroup key={el.id} languageId={languageId} groupData={el} />
			))}
		</div>
	);
};

export default InputFields;
